import { render, staticRenderFns } from "./AuctionList.vue?vue&type=template&id=aef9b790"
import script from "./AuctionList.vue?vue&type=script&lang=js"
export * from "./AuctionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports